import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const timeBomb: Example = {
  id: "time-bomb",
  title: "Time bomb",
  group: "technique",
  environment: "browser",
  mode: "script",
  summary: "Waits two weeks, then acts only after its activation date",
  explainer:
    "The script schedules its payload 14 days out. The virtual clock jumps there instantly: look for the time-skip divider, the `delayed:14d` tag, and the delayed trigger that fires the payload. Set the context's date past 2026-10-20 and it acts immediately instead.",
  code,
  context: { now: Date.UTC(2026, 9, 12, 9) },
  expect: golden as Example["expect"],
};
